import * as moment from 'moment';
import * as Constants from '@/constants';

export default class {
  constructor(student) {
    const serviceInfo = student.form.serviceInformation;
    const sessionDate = moment(serviceInfo.sessionDate, 'MM-DD-YYYY').format('YYYY-MM-DD');
    // validations will make sure medicaid exists if needLevel !== absent
    const hasMedicaid = serviceInfo.needLevel !== Constants.ABSENT;
    this.providerUserId = student.providerUserId;
    this.providerHUserId = student.providerHUserId;
    this.providerId = student.providerId;
    this.supportId = student.serviceId;
    this.supportTypeId = student.serviceTypeId;
    this.needLevel = serviceInfo.needLevel;
    this.noShow = serviceInfo.noShow;
    this.credentialType = serviceInfo.credentialType;
    this.studentId = student.studentId;
    this.hStudentId = student.hStudentId;
    this.sessionDate = sessionDate;
    this.sessionTime = serviceInfo.sessionTime || null;
    this.sessionMinutes = serviceInfo.sessionMinutes ? Number(serviceInfo.sessionMinutes) : null;
    this.locationId = serviceInfo.location.locationId || null;
    this.agencyId = null;
    this.locationOther = serviceInfo.locationOther || null;
    this.deliveryMode = serviceInfo.deliveryMode;
    this.roomName = serviceInfo.roomName;
    this.licenseAttestUserId = serviceInfo.licenseAttestUserId;
    this.licenseAttestDate = serviceInfo.licenseAttestDate;
    this.supervisorUserId = serviceInfo.supervisorUserId;
    this.supervisorName = serviceInfo.supervisorName;
    this.supervisorDate = serviceInfo.supervisorDate;
    // unused field
    this.serviceDocumentation = null;
    this.bus = serviceInfo.bus || false;
    // unused field
    this.hardToFill = null;
    this.verified = false;
    this.locId = null;
    this.rfpId = null;
    // clear out fields that aren't shown
    if (serviceInfo.needLevel === Constants.ABSENT) {
      this.sessionTime = null;
      this.sessionMinutes = null;
      this.deliveryMode = null;
      this.roomName = null;
      this.bus = false;
    } else {
      this.noShow = null;
    }
    if (serviceInfo.deliveryMode !== Constants.IN_PERSON) {
      this.roomName = null;
    }
    // set medicaid information if it exists
    this.medicaid = hasMedicaid;
    if (hasMedicaid) {
      this.medicaidMinutes = student.form.totalReimbursableMinutes;
      this.medicaidSessions = student.form.medicaid.map((procedure) => {
        return {
          ...procedure,
          studentId: student.studentId,
          hStudentId: student.hStudentId,
          providerUserId: student.providerUserId,
          providerHUserId: student.providerHUserId,
          procedureDate: sessionDate
        };
      });
    }
    this.notes = student.form.notes || null;
  }
}



// WEBPACK FOOTER //
// ./src/utils/service-log-submission-class.js